import { getP } from '../../core/selectors.js';
import { UI, save } from '../../core/store.js';
import { readImg, uid } from '../../core/util.js';
import { render } from '../../core/shell.js';
import { toast } from '../../core/ui.js';
import { actions } from './actions.js';
import { presentSlides, refreshSlide, slideById } from './view.js';

// Typing in the brief editor updates the slide live. Elements use data-inp = bfield | btable | bref.
function slideFor(t) {
  const p = getP(UI.pid);
  return p ? slideById(p, t.dataset.sid) : null;
}
export const inputs = {
  bfield(t) {
    const s = slideFor(t); if (!s) return;
    const d = t.dataset;
    s[d.k] = d.kind === 'lines' ? t.value.split('\n').map((x) => x.trim()).filter(Boolean) : t.value;
    save(); refreshSlide();
  },
  btable(t) {
    const s = slideFor(t); if (!s) return;
    s.rows[Number(t.dataset.i)][t.dataset.k] = t.value;
    save(); refreshSlide();
  },
  bref(t) {
    const s = slideFor(t); if (!s) return;
    const x = s.items.find((i) => i.id === t.dataset.id);
    if (x) x.cap = t.value;
    save(); refreshSlide();
  }
};

// Presentation mode keyboard: arrows move, Escape closes. Swallows all keys while presenting.
export function presentKey(e) {
  if (!UI.pr) return false;
  if (e.key === 'Escape') { actions.pclose(); return true; }
  if (e.key === 'ArrowRight' || e.key === ' ') {
    if (e.target.closest && e.target.closest('button') && e.key === ' ') return true;
    e.preventDefault();
    if (presentSlides().length - 1 > UI.pr.idx) actions.pnext();
    return true;
  }
  if (e.key === 'ArrowLeft') { if (UI.pr.idx > 0) actions.pprev(); return true; }
  return true;
}
// Clicking the slide itself advances it.
export function presentClick(e) {
  if (e.target.closest('[data-act]')) return false;
  if (UI.pr && e.target.closest('.pres-stage .sl') && !e.target.closest('a') && UI.pr.idx < presentSlides().length - 1) { actions.pnext(); return true; }
  return false;
}
// Reference images chosen in the brief editor (UI.upMode === 'ref').
export function uploadRefs(files) {
  const p = getP(UI.pid); let pending = files.length;
  files.forEach((f) => readImg(f, (url) => {
    if (url) { const s = slideById(p, UI.refSid); if (s) s.items.push({ id: uid(), img: url, cap: f.name.replace(/\.[^.]+$/, ''), url: '' }); }
    if (--pending === 0) { save(); render(); toast('Reference added'); }
  }));
}
